import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

const STORAGE_KEY = "supercast_review_prompted";

export default class extends BridgeComponent {
  static component = "review-prompt";
  static values = { promptImmediately: Boolean };

  connect() {
    super.connect();
    if (this.promptImmediatelyValue) {
      this.triggerPrompt();
      this.element.remove();
      return;
    }
    this._handler = this.triggerPrompt.bind(this);
    window.addEventListener("supercast:requestReview", this._handler);
  }

  disconnect() {
    window.removeEventListener("supercast:requestReview", this._handler);
  }

  triggerPrompt() {
    if (localStorage.getItem(STORAGE_KEY)) return;
    localStorage.setItem(STORAGE_KEY, "1");
    this.send("prompt");
  }
}
